import React from 'react';

import {rollbackFieldMigration} from 'schemas/fields/field-migration/SchemaFieldMigrationDAO';
import {TagSchemaFileSettingsQuery_tagSchema_TagSchemaNode_activeMigration_FieldDataMigrationNode_sourceField_SchemaFieldNode as SourceField} from 'settings/registry/__generated/TagSchemaFileSettingsQuery';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import {withLoadingScreen} from 'util/Promises';

interface FieldMigrationConfirmRollbackModalProps {
  sourceField: SourceField;
  onRequestRollback: () => Promise<void>;
  onRequestClose: () => void;
  onRequestCloseParent?: () => void;
}

export default function FieldMigrationConfirmRollbackModal(
  props: FieldMigrationConfirmRollbackModalProps
): JSX.Element {
  const {sourceField, onRequestRollback, onRequestClose} = props;

  const rollbackOnClick = async (): Promise<void> => {
    await withLoadingScreen(
      (async () => {
        await rollbackFieldMigration(sourceField.apiId);
        await onRequestRollback();
        onRequestClose();
        if (props.onRequestCloseParent) {
          props.onRequestCloseParent();
        }
      })()
    );
  };

  return (
    <Modal
      title="Confirm Rollback Migration"
      onRequestClose={onRequestClose}
      scrollable={true}
      mediumLarge={true}
      className="modal-text-only"
      buttons={[
        {text: 'Cancel', cancel: true},
        {text: 'Rollback migration', onClick: rollbackOnClick, style: ButtonStyle.NEGATIVE},
      ]}
    >
      <div>
        <p>
          The newly created destination field and all data created by this field migration will be deleted.
        </p>
        <p>
          The original field "{props.sourceField.name}" and its data will not be affected. Data entered during
          the migration will be preserved on this field, and can be safely re-migrated in the future.
        </p>
      </div>
    </Modal>
  );
}
